export default __webpack_public_path__ + "static/media/washupStep2-2.43bee6d6.png";